import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="android" api="clear-queue" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void clearQueue()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`Analytics.clearQueue();
`}</code></pre>
    <Variant platform="ios" api="clear-queue" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func clearQueue()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`ACPAnalytics.clearQueue()
`}</code></pre>
    <h4 {...{
      "id": "objective-c"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) clearQueue;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`[ACPAnalytics clearQueue];
`}</code></pre>
    <Variant platform="react-native" api="clear-queue" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`clearQueue();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.clearQueue();
`}</code></pre>
    <Variant platform="flutter" api="clear-queue" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "dart"
    }}>{`Dart`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`Future<void> clearQueue();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`FlutterACPAnalytics.clearQueue();
`}</code></pre>
    <Variant platform="cordova" api="clear-queue" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "cordova"
    }}>{`Cordova`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.clearQueue = function(success, fail);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`success`}</em>{` is a callback containing a general success message if the clearQueue API executed without any errors.`}</li>
      <li parentName="ul"><em parentName="li">{`fail`}</em>{` is a callback containing error information if the clearQueue API was executed with errors.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.clearQueue(function (handleCallback) {
  console.log("AdobeExperienceSDK: Clear queued hits successful. " + handleCallback);
} ,function (handleError) {
  console.log("AdobeExperenceSDK: Failed to clear queued hits: " + handleError);
});
`}</code></pre>
    <Variant platform="unity" api="clear-queue" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "c"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public static void ClearQueue()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPAnalytics.ClearQueue();
`}</code></pre>
    <Variant platform="xamarin" api="clear-queue" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "c-1"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public static void ClearQueue ();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPAnalytics.ClearQueue();
`}</code></pre>
    <Variant platform="android" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "java-1"
    }}>{`Java`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`String analyticsExtensionVersion = Analytics.extensionVersion();
`}</code></pre>
    <Variant platform="ios" api="extension-version" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-1"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func extensionVersion()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let analyticsExtensionVersion  = ACPAnalytics.extensionVersion()
`}</code></pre>
    <h4 {...{
      "id": "objective-c-1"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (nonnull NSString*) extensionVersion;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`NSString *analyticsExtensionVersion = [ACPAnalytics extensionVersion];
`}</code></pre>
    <Variant platform="react-native" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "javascript-1"
    }}>{`JavaScript`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.extensionVersion().then(analyticsExtensionVersion => console.log("AdobeExperienceSDK: ACPAnalytics version: " + analyticsExtensionVersion));
`}</code></pre>
    <Variant platform="flutter" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "dart-1"
    }}>{`Dart`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`String analyticsExtensionVersion = await FlutterACPAnalytics.extensionVersion;
`}</code></pre>
    <Variant platform="cordova" api="extension-version" repeat="2" mdxType="Variant" />
    <h3 {...{
      "id": "cordova-1"
    }}>{`Cordova`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.extensionVersion(function(version) {  
   console.log("ACPAnalytics version: " + version);
}, function(error) {  
   console.log(error);  
});
`}</code></pre>
    <Variant platform="unity" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "c-2"
    }}>{`C#`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`string analyticsExtensionVersion = ACPAnalytics.ExtensionVersion();
`}</code></pre>
    <Variant platform="xamarin" api="extension-version" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "c-3"
    }}>{`C#`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`string analyticsExtensionVersion = ACPAnalytics.ExtensionVersion();
`}</code></pre>
    <Variant platform="android" api="get-queue-size" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java-2"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{` public static void getQueueSize(final AdobeCallback<Long> callback)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is invoked with the queue size value. When an AdobeCallbackWithError is provided, an AdobeError can be returned in the eventuality of an unexpected error or if the default timeout (5000ms) is met before the callback is returned with queue size.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`Analytics.getQueueSize(new AdobeCallback<Long>() {
    @Override
    public void call(final Long queueSize) {
        // handle the queueSize
    }
});
`}</code></pre>
    <Variant platform="ios" api="get-queue-size" repeat="11" mdxType="Variant" />
    <h4 {...{
      "id": "swift-2"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func getQueueSize(_ callback: @escaping (UInt) -> Void)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`ACPAnalytics.getQueueSize { (queueSize) in    
     // handle queue size   
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-2"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void) getQueueSize: (nonnull void (^) (NSUInteger queueSize)) callback;
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is invoked with the queue size value.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[ACPAnalytics getQueueSize: ^(NSUInteger queueSize) {    
    // handle queue size
}];
`}</code></pre>
    <Variant platform="react-native" api="get-queue-size" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "javascript-2"
    }}>{`JavaScript`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`getQueueSize(): Promise<?integer>;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.getQueueSize().then(size => console.log("AdobeExperienceSDK: Queue size: " + size));
`}</code></pre>
    <Variant platform="flutter" api="get-queue-size" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "dart-2"
    }}>{`Dart`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`Future<int> getQueueSize;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`int queueSize;

try {
    queueSize = await FlutterACPAnalytics.queueSize;
} on PlatformException {
    log("Failed to get the queue size");
}
`}</code></pre>
    <Variant platform="cordova" api="get-queue-size" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "cordova-2"
    }}>{`Cordova`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.getQueueSize = function(success, fail);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`success`}</em>{` is a callback containing the `}<inlineCode parentName="li">{`queue size`}</inlineCode>{` if the getQueueSize API executed without any errors.`}</li>
      <li parentName="ul"><em parentName="li">{`fail`}</em>{` is a callback containing error information if the getQueueSize API was executed with errors.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPAnalytics.getQueueSize(function (handleCallback) {
  console.log("AdobeExperienceSDK: Queue size: " + handleCallback);
} ,function (handleError) {
  console.log("AdobeExperenceSDK: Failed to get queue size: " + handleError);
});
`}</code></pre>
    <Variant platform="unity" api="get-queue-size" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "c-4"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public static void GetQueueSize(AdobeGetQueueSizeCallback callback)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is a callback containing the `}<inlineCode parentName="li">{`queue size`}</inlineCode>{` if the GetQueueSize API executed without any errors.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`[MonoPInvokeCallback(typeof(AdobeGetQueueSizeCallback))]
public static void HandleAdobeGetQueueSizeCallback(long queueSize)
{
    Debug.Log("Queue size is : " + queueSize);
}
ACPAnalytics.GetQueueSize(HandleAdobeGetQueueSizeCallback);
`}</code></pre>
    <Variant platform="xamarin" api="get-queue-size" repeat="13" mdxType="Variant" />
    <h4 {...{
      "id": "c-5"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`iOS`}</strong></p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public unsafe static void GetQueueSize (Action<nuint> callback);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is a callback containing the `}<inlineCode parentName="li">{`queue size`}</inlineCode>{` if the GetQueueSize API executed without any errors.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPAnalytics.GetQueueSize(callback => {
  Console.WriteLine("Queue size: " + callback);
});
`}</code></pre>
    <p><strong parentName="p">{`Android`}</strong></p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public unsafe static void GetQueueSize (IAdobeCallback callback);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is a callback containing the `}<inlineCode parentName="li">{`queue size`}</inlineCode>{` if the GetQueueSize API executed without any errors.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPAnalytics.GetQueueSize(new StringCallback());

class StringCallback : Java.Lang.Object, IAdobeCallback
{
  public void Call(Java.Lang.Object stringContent)
  {
    if (stringContent != null)
    {
      Console.WriteLine("Queue size: " + stringContent);
    }
    else
    {
      Console.WriteLine("null content in string callback");
    }
  }
}
`}</code></pre>
    <Variant platform="ios" api="get-queue-size-with-completion-handler" repeat="11" mdxType="Variant" />
    <h4 {...{
      "id": "swift-3"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func getQueueSize(completionHandler: @escaping (UInt, Error?) -> Void)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`ACPAnalytics.getQueueSizeWithCompletionHandler { (queueSize, error) in    
    // Handle error (if non-nil) or use queueSize.  
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-3"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void) getQueueSizeWithCompletionHandler: (nonnull void (^) (NSUInteger queueSize, NSError* __nullable error)) completionHandler;
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`completionHandler`}</em>{` is invoked with the queue size value or an NSError if an unexpected error occurs or the request times out.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[ACPAnalytics getQueueSizeWithCompletionHandler: ^(NSUInteger queueSize, NSError * _Nullable error) {    
    // Handle error (if non-nil) or use queueSize.
}];
`}</code></pre>
    <Variant platform="android" api="get-tracking-identifier" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java-3"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{` public static void
   getTrackingIdentifier(final AdobeCallback<String> callback)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is invoked with the tracking Identifier string value. When an AdobeCallbackWithError is provided, an AdobeError can be returned in the eventuality of an unexpected error or if the default timeout (5000ms) is met before the callback is returned with analytics tracking identifier.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`Analytics.getTrackingIdentifier(new AdobeCallback<String>() {
    @Override
    public void call(final String trackingIdentifier) {
        // check the trackingIdentifier value    
    }
});
`}</code></pre>
    <Variant platform="ios" api="get-tracking-identifier" repeat="11" mdxType="Variant" />
    <h4 {...{
      "id": "swift-4"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func getTrackingIdentifier(_ callback: @escaping (String?) -> Void)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`ACPAnalytics.getTrackingIdentifier { (trackingIdentifier) in
    // check the trackingIdentifier value  
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-4"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void) getTrackingIdentifier: (nonnull void (^) (NSString* __nullable trackingIdentifier)) callback;
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is invoked with the tracking Identifier string value.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[ACPAnalytics getTrackingIdentifier:^(NSString * _Nullable trackingIdentifier) {
    // check the trackingIdentifier value  
}];
`}</code></pre>
    <Variant platform="react-native" api="get-tracking-identifier" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "javascript-3"
    }}>{`JavaScript`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`getTrackingIdentifier();
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is invoked with the tracking Identifier string value.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.getTrackingIdentifier().then(identifier => console.log("AdobeExperienceSDK: Tracking identifier: " + identifier));
`}</code></pre>
    <Variant platform="flutter" api="get-tracking-identifier" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "dart-3"
    }}>{`Dart`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`Future<String> getTrackingIdentifier;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`String trackingId;

try {
    trackingId = await FlutterACPAnalytics.trackingIdentifier;
} on PlatformException {
    log("Failed to get the tracking identifier");
}
`}</code></pre>
    <Variant platform="cordova" api="get-tracking-identifier" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "cordova-3"
    }}>{`Cordova`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.getTrackingIdentifier = function(success, fail);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`success`}</em>{` is a callback containing the tracking Identifier string value.`}</li>
      <li parentName="ul"><em parentName="li">{`fail`}</em>{` is a callback containing error information if the getTrackingIdentifier API was executed with errors.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.getTrackingIdentifier(function (handleCallback) {
  console.log("AdobeExperienceSDK: Retrieved tracking identifier: " + handleCallback);
} ,function (handleError) {
  console.log("AdobeExperenceSDK: Failed to retrieve tracking identifier: " + handleError);
});
`}</code></pre>
    <Variant platform="unity" api="get-tracking-identifier" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "c-6"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public static void GetTrackingIdentifier(AdobeGetTrackingIdentifierCallback callback)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is a callback containing the tracking Identifier string value.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`[MonoPInvokeCallback(typeof(AdobeGetTrackingIdentifierCallback))]
public static void HandleAdobeGetTrackingIdentifierCallback(string trackingIdentifier)
{
    Debug.Log("Tracking identifier is : " + trackingIdentifier);
}
ACPAnalytics.GetTrackingIdentifier(HandleAdobeGetTrackingIdentifierCallback);
`}</code></pre>
    <Variant platform="xamarin" api="get-tracking-identifier" repeat="13" mdxType="Variant" />
    <h4 {...{
      "id": "c-7"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`iOS`}</strong></p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public unsafe static void GetTrackingIdentifier (Action<NSString> callback);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is a callback containing the tracking Identifier string value.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPAnalytics.GetTrackingIdentifier(callback => {
  Console.WriteLine("Tracking identifier: " + callback);
});
`}</code></pre>
    <p><strong parentName="p">{`Android`}</strong></p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public unsafe static void GetTrackingIdentifier (IAdobeCallback callback);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is a callback containing the tracking Identifier string value.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPAnalytics.GetTrackingIdentifier(new StringCallback());

class StringCallback : Java.Lang.Object, IAdobeCallback
{
  public void Call(Java.Lang.Object stringContent)
  {
    if (stringContent != null)
    {
      Console.WriteLine("Tracking identifier: " + stringContent);
    }
    else
    {
      Console.WriteLine("null content in string callback");
    }
  }
}
`}</code></pre>
    <Variant platform="ios" api="get-tracking-identifier-with-completion-handler" repeat="11" mdxType="Variant" />
    <h4 {...{
      "id": "swift-5"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func getTrackingIdentifier(completionHandler: @escaping (String?, Error?) -> Void)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`completionHandler`}</em>{` is invoked with the tracking Identifier string value. or an NSError if an unexpected error occurs or the request times out.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`ACPAnalytics.getTrackingIdentifierWithCompletionHandler { (trackingIdentifier, error) in    
     // Handle the error (if non-nil) or use the trackingIdentifier value.
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-5"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void) getTrackingIdentifierWithCompletionHandler: (nonnull void (^) (NSString* __nullable trackingIdentifier, NSError* __nullable error)) completionHandler;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[ACPAnalytics getTrackingIdentifierWithCompletionHandler:^(NSString * _Nullable trackingIdentifier, NSError * _Nullable error) {
    // Handle the error (if non-nil) or use the trackingIdentifier value.
}];
`}</code></pre>
    <Variant platform="android" api="get-visitor-identifier" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java-4"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void getVisitorIdentifier(AdobeCallback<String> callback)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is invoked with the visitor identifier value. When an AdobeCallbackWithError is provided, an AdobeError can be returned in the eventuality of an unexpected error or if the default timeout (5000ms) is met before the callback is returned with visitor identifier.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`Analytics.getVisitorIdentifier(new AdobeCallback<String>() {
    @Override
    public void call(final String visitorIdentifier) {
        // check the visitorIdentifier value    
    }
});
`}</code></pre>
    <Variant platform="ios" api="get-visitor-identifier" repeat="11" mdxType="Variant" />
    <h4 {...{
      "id": "swift-6"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func getVisitorIdentifier(_ callback: @escaping (String?) -> Void)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is invoked with the visitor identifier value.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`ACPAnalytics.getVisitorIdentifier { (visitorIdentifier) in
    // check the visitorIdentifier value  
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-6"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void) getVisitorIdentifier: (nonnull void (^) (NSString* __nullable visitorIdentifier)) callback;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[ACPAnalytics getVisitorIdentifier:^(NSString * _Nullable visitorIdentifier) {
    // check the visitorIdentifier value   
}];
`}</code></pre>
    <Variant platform="react-native" api="get-visitor-identifier" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "javascript-4"
    }}>{`JavaScript`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`getVisitorIdentifier();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.getVisitorIdentifier().then(vid => console.log("AdobeExperienceSDK: Visitor identifier: " + vid));
`}</code></pre>
    <Variant platform="flutter" api="get-visitor-identifier" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "dart-4"
    }}>{`Dart`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`Future<String> visitorIdentifier;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`String visitorId;

try {
    visitorId = await FlutterACPAnalytics.visitorIdentifier;
} on PlatformException {
    visitorId = "Failed to get the visitor identifier";
}
`}</code></pre>
    <Variant platform="cordova" api="get-visitor-identifier" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "cordova-4"
    }}>{`Cordova`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.getVisitorIdentifier = function(success, fail);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`success`}</em>{` is a callback containing the `}<inlineCode parentName="li">{`Visitor Identifier`}</inlineCode>{` string if the getVisitorIdentifier API executed without any errors.`}</li>
      <li parentName="ul"><em parentName="li">{`fail`}</em>{` is a callback containing error information if the getVisitorIdentifier API was executed with errors.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.getVisitorIdentifier(function (handleCallback) {
  console.log("AdobeExperienceSDK: Retrieved custom visitor identifier: " + handleCallback);
} ,function (handleError) {
  console.log("AdobeExperenceSDK: Failed to retrieve custom visitor identifier: " + handleError);
});
`}</code></pre>
    <Variant platform="unity" api="get-visitor-identifier" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "c-8"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public static void GetVisitorIdentifier(AdobeGetVisitorIdentifierCallback callback)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is a callback containing the `}<inlineCode parentName="li">{`Visitor Identifier`}</inlineCode>{` string if the GetVisitorIdentifier API executed without any errors.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`[MonoPInvokeCallback(typeof(AdobeGetVisitorIdentifierCallback))]
public static void HandleAdobeGetVisitorIdentifierCallback(string visitorIdentifier)
{
    Debug.Log("Visitor identifier is : " + visitorIdentifier);
}
ACPAnalytics.GetVisitorIdentifier(HandleAdobeGetVisitorIdentifierCallback);
`}</code></pre>
    <Variant platform="xamarin" api="get-visitor-identifier" repeat="13" mdxType="Variant" />
    <h4 {...{
      "id": "c-9"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`iOS`}</strong></p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public unsafe static void GetVisitorIdentifier (Action<NSString> callback);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is a callback containing the visitor Identifier string value.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPAnalytics.GetVisitorIdentifier(callback => {
  Console.WriteLine("Visitor identifier: " + callback);
});
`}</code></pre>
    <p><strong parentName="p">{`Android`}</strong></p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public unsafe static void GetVisitorIdentifier (IAdobeCallback callback);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is a callback containing the visitor Identifier string value.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPAnalytics.GetVisitorIdentifier(new StringCallback());

class StringCallback : Java.Lang.Object, IAdobeCallback
{
  public void Call(Java.Lang.Object stringContent)
  {
    if (stringContent != null)
    {
      Console.WriteLine("Visitor identifier: " + stringContent);
    }
    else
    {
      Console.WriteLine("null content in string callback");
    }
  }
}
`}</code></pre>
    <Variant platform="ios" api="get-visitor-identifier-with-completion-handler" repeat="11" mdxType="Variant" />
    <h4 {...{
      "id": "swift-7"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func getVisitorIdentifier(completionHandler: @escaping (String?, Error?) -> Void)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`completionHandler`}</em>{` is invoked with the visitor identifier value or an NSError if an unexpected error occurs or the request times out.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`ACPAnalytics.getVisitorIdentifierWithCompletionHandler { (visitorIdentifier, error) in
    // Handle the error (if non-nil) or use the visitorIdentifier value
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-7"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) getVisitorIdentifierWithCompletionHandler: (nonnull void (^) (NSString* __nullable visitorIdentifier, NSError* __nullable error)) completionHandler;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`[ACPAnalytics getVisitorIdentifierWithCompletionHandler:^(NSString * _Nullable visitorIdentifier, NSError * _Nullable error) {
    // Handle the error (if non-nil) or use the visitorIdentifier value
}];
`}</code></pre>
    <Variant platform="android" api="send-queued-hits" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-5"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void sendQueuedHits()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`Analytics.sendQueuedHits();
`}</code></pre>
    <Variant platform="ios" api="send-queued-hits" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-8"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func sendQueuedHits()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`ACPAnalytics.sendQueuedHits()
`}</code></pre>
    <h4 {...{
      "id": "objective-c-8"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void) sendQueuedHits;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[ACPAnalytics sendQueuedHits];
`}</code></pre>
    <Variant platform="react-native" api="send-queued-hits" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "javascript-5"
    }}>{`JavaScript`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`sendQueuedHits();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.sendQueuedHits();
`}</code></pre>
    <Variant platform="flutter" api="send-queued-hits" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "dart-5"
    }}>{`Dart`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`Future<void> sendQueuedHits();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`FlutterACPAnalytics.sendQueuedHits();
`}</code></pre>
    <Variant platform="cordova" api="send-queued-hits" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "cordova-5"
    }}>{`Cordova`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.sendQueuedHits = function(success, fail);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`success`}</em>{` is a callback containing a general success message if the sendQueuedHits API executed without any errors.`}</li>
      <li parentName="ul"><em parentName="li">{`fail`}</em>{` is a callback containing error information if the sendQueuedHits API was executed with errors.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.sendQueuedHits(function (handleCallback) {
  console.log("AdobeExperienceSDK: Send queued hits successful. " + handleCallback);
} ,function (handleError) {
  console.log("AdobeExperenceSDK: Failed to send queued hits: " + handleError);
});
`}</code></pre>
    <Variant platform="unity" api="send-queued-hits" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "c-10"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public static void SendQueuedHits()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPAnalytics.SendQueuedHits();
`}</code></pre>
    <Variant platform="xamarin" api="send-queued-hits" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "c-11"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public static void SendQueuedHits ();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPAnalytics.SendQueuedHits();
`}</code></pre>
    <Variant platform="android" api="set-visitor-identifier" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java-6"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{` public static void setVisitorIdentifier(final String visitorIdentifier)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`visitorIdentifier`}</em>{` is the new value for the visitor identifier.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`Analytics.setVisitorIdentifier("custom_identifier");
`}</code></pre>
    <Variant platform="ios" api="set-visitor-identifier" repeat="11" mdxType="Variant" />
    <h4 {...{
      "id": "swift-9"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func setVisitorIdentifier(_ visitorIdentifier: String)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`visitorIdentifier`}</em>{` is the new value for the visitor identifier.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`ACPAnalytics.setVisitorIdentifier("custom_identifier")
`}</code></pre>
    <h4 {...{
      "id": "objective-c-9"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`+ (void) setVisitorIdentifier: (nonnull NSString*) visitorIdentifier;
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[ACPAnalytics setVisitorIdentifier:@"custom_identifier"];
`}</code></pre>
    <Variant platform="react-native" api="set-visitor-identifier" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "javascript-6"
    }}>{`JavaScript`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`setVisitorIdentifier(visitorIdentifier);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`visitorIdentifier`}</em>{` is the new value for the visitor identifier.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.setVisitorIdentifier("custom_identifier");
`}</code></pre>
    <Variant platform="flutter" api="set-visitor-identifier" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "dart-6"
    }}>{`Dart`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`Future<void> setVisitorIdentifier(visitorIdentifier);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`visitorIdentifier`}</em>{` is the new value for the visitor identifier.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`FlutterACPAnalytics.setVisitorIdentifier("yourVisitorId");
`}</code></pre>
    <Variant platform="cordova" api="set-visitor-identifier" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "cordova-6"
    }}>{`Cordova`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.setVisitorIdentifier(visitorIdentifier, success, fail);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`visitorIdentifier`}</em>{` is the new value for the visitor identifier.`}</li>
      <li parentName="ul"><em parentName="li">{`success`}</em>{` is a callback containing a general success message if the setVisitorIdentifier API executed without any errors.`}</li>
      <li parentName="ul"><em parentName="li">{`fail`}</em>{` is a callback containing error information if the setVisitorIdentifier API was executed with errors.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`ACPAnalytics.setVisitorIdentifier("custom_identifier", function (handleCallback) {
  console.log("AdobeExperienceSDK: Custom visitor identifier set successfully. " + handleCallback);
} ,function (handleError) {
  console.log("AdobeExperenceSDK: Failed to set custom visitor identifier: " + handleError);
});
`}</code></pre>
    <Variant platform="unity" api="set-visitor-identifier" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "c-12"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public static void SetVisitorIdentifier(string visitorId)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`visitorId`}</em>{` is the new value for the visitor identifier.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPAnalytics.SetVisitorIdentifier("VisitorIdentifier");
`}</code></pre>
    <Variant platform="xamarin" api="set-visitor-identifier" repeat="11" mdxType="Variant" />
    <h4 {...{
      "id": "c-13"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`iOS`}</strong></p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public static void SetVisitorIdentifier (string visitorIdentifier);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`visitorIdentifier`}</em>{` is the new value for the visitor identifier.`}</li>
    </ul>
    <p><strong parentName="p">{`Android`}</strong></p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public unsafe static void SetVisitorIdentifier (string visitorID);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`visitorID`}</em>{` is the new value for the visitor identifier.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`ACPAnalytics.SetVisitorIdentifier("VisitorIdentifier");
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      